import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import Button from "../../components/CustomButtons/Button";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomDateField from "components/UpdateUi/CustomDateField";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import { parseDate } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
import ToastModal from "views/components/ToastModal";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  textFieldContainer: {
    fontSize: "16px",
    fontWeight: "600",
    margin: "2% 2% 0px 0px",
  },
}));

const ReferenceDetails = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  // Retrieve loanNumber from state
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [reference1Name, setReference1Name] = useState("");
  const [referencePhone1, setReferencePhone1] = useState("");
  const [reference1RelationShip, setReference1RelationShip] = useState("");
  const [reference1RelationShip2, setReference1RelationShip2] = useState("");
  const [relationshipList, setRelationshipList] = useState([]);
  const [reference2Name, setReference2Name] = useState("");
  const [referencePhone2, setReferencePhone2] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [disaledFields, setDisabledFields] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  console.log(leadId, "flaljdfkjadjk");
  useEffect(() => {
    // if (leadId) {
    fetchLoanSummary();
    // }
  }, [leadId]);

  const fetchLoanSummary = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_RELATIONSHIP_TYPE_API,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code === 401) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const dataArr = result.data.map((item) => ({
        value: item.relationshipName,
        label: toCamelCase(item.relationshipName),
      }));
      setRelationshipList(dataArr);
      if (dataArr.length > 0) {
        getReferenceDetails();
      }
    }
  };
  const getReferenceDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_LEAD_REFERENCE_DETAILS_API + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.length > 0) {
      setDisabledFields(true);
      setReference1RelationShip(result?.data?.[0]?.referalRelation);
      setReference1Name(result?.data?.[0]?.referalName);
      setReferencePhone1(result?.data?.[0]?.phoneNumber);
      setReference1RelationShip2(result?.data?.[1]?.referalRelation);
      setReference2Name(result?.data?.[1]?.referalName);
      setReferencePhone2(result?.data?.[1]?.phoneNumber);
    }
  };

  const sumitLoanDetails = async () => {
    const res = await apiHandler({
      url: endpoint.CREATE_LEAD_REFERENCE_DETAILS_API + leadId,
      method: "POST",
      authToken: authToken,
      data: [
        {
          referalRelation: reference1RelationShip,
          referalName: reference1Name,
          phoneNumber: referencePhone1,
        },
        {
          referalRelation: reference1RelationShip2,
          referalName: reference2Name,
          phoneNumber: referencePhone2,
        },
      ],
    });
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      navigate("/journey/loanTenureDetails");
    }
  };

  const isFormValid = () => {
    if (disaledFields) return true;

    return (
      reference1Name.trim() !== "" &&
      reference1RelationShip !== "" &&
      referencePhone1.trim().length === 10 &&
      reference2Name.trim() !== "" &&
      reference1RelationShip2 !== "" &&
      referencePhone2.trim().length === 10
    );
  };

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="Reference Details"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.textFieldContainer}
          >
            {"Reference 1"}
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Name"
              placeholder="Name"
              value={reference1Name}
              onChange={(e) => setReference1Name(e.target.value)}
              style={classes.inputField}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Relationship"
              value={reference1RelationShip}
              onChange={(e) => setReference1RelationShip(e.target.value)}
              options={relationshipList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Mobile Number"
              placeholder="Mobile Number"
              value={referencePhone1}
              onChange={(e) => setReferencePhone1(e.target.value)}
              style={classes.inputField}
              disabled={disaledFields}
              type="number"
              maxLength="10"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.textFieldContainer}
          >
            {"Reference 2"}
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Name"
              placeholder="Name"
              value={reference2Name}
              onChange={(e) => setReference2Name(e.target.value)}
              style={classes.inputField}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Relationship"
              value={reference1RelationShip2}
              onChange={(e) => setReference1RelationShip2(e.target.value)}
              options={relationshipList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Mobile Number"
              placeholder="Mobile Number"
              value={referencePhone2}
              onChange={(e) => setReferencePhone2(e.target.value)}
              style={classes.inputField}
              disabled={disaledFields}
              type="number"
              maxLength="10"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <BottomButton
          button1={"Next"}
          button1click={sumitLoanDetails}
          disabled1={!isFormValid()}
        />
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default ReferenceDetails;
